import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="max-w-2xl mx-auto px-6 py-24">
      <div className="rm-card p-10 text-center">
        <XCircle size={48} className="mx-auto text-red-500" />
        <h1 className="font-display text-3xl font-bold text-[#0f172a] mt-6">Płatność anulowana</h1>
        <p className="text-slate-600 mt-3">
          Nie pobraliśmy żadnych środków. Możesz wrócić i spróbować ponownie.
        </p>
        <div className="flex gap-3 justify-center mt-8 flex-wrap">
          <Link to="/zamow-sim" className="rm-btn-primary">Wróć do zamówienia</Link>
          <Link to="/" className="px-6 py-3 rounded-full border border-[#1f3a8a] text-[#1f3a8a] font-bold hover:bg-[#1f3a8a] hover:text-white transition">
            Strona główna
          </Link>
        </div>
      </div>
    </div>
  );
}
